import axios from "axios";

export const getEducationStates = callback => {
  var promise = axios({
    method: "get",
    url: "/api/trabajando_education_states"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
